// extracted by mini-css-extract-plugin
export default {"dropzone":"dropzone_dropzone__Dq-lj","children":"dropzone_children__Fs8Lw","pointerEvent":"dropzone_pointerEvent__kkTgB","pulse":"dropzone_pulse__vCTr2"};